/* The FAQ measured-height animation, extracted to a shared
 * asset in a Liquid tag javascript bundles only load on pages whose own
 * sections carry one, so the v2 page silently lost the animation. Both
 * book-consultation sections load this file; the bound flag keeps a
 * double include harmless.
 */
if (!window.__drFaqBound) {
  window.__drFaqBound = true;
/* FAQ accordion: animate open AND close.
     The <details> element snaps, because the UA simply stops rendering the
     content when `open` flips. So: intercept the summary click, keep the
     element OPEN for the whole close animation, and only flip `open` to false
     once the height has finished collapsing. Height is measured, not guessed,
     so a long answer can never be clipped by a max-height cap.
     prefers-reduced-motion → do nothing, let the browser snap natively.*/
  document.addEventListener('DOMContentLoaded', () => {
    /* The SAME controller now serves the guide accordions
       (.guide-acc). One measured-height animation, not a second copy:
       lesson was that a bare <details> snaps, and that a
       max-height cap clips long panels. Selector pairs are declared
       together so a new surface is one line, never a fork.*/
    const SURFACES = [
      { item: '.bc-faq__item', summary: '.bc-faq__q', panel: '.bc-faq__panel' },
      { item: '.guide-acc', summary: '.guide-acc__summary', panel: '.guide-acc__panel' },
      /* Job 2 (B14/X8,: "it's a bit in your face at the
         moment, it just opened") — the PDP's product-description accordions
         join the SAME controller. One measured-height animation for three
         surfaces, never a fourth copy; this is the "a new surface is one
         line" the note above promises. ⚠ The PDP's bodies were direct
         children of <details> and had no overflow-hidden wrapper, so each is
         now wrapped in .pdp-acc__panel — the pattern needs a box whose
         height can be animated (book-consultation.liquid records the same
         requirement). ⚠ Also serves the AUCTION PDP, which renders
         pdp__accordions from its own section.*/
      { item: '.pdp-acc', summary: '.pdp-acc__summary', panel: '.pdp-acc__panel' },
      /* The Materials & Construction cards' READ MORE / READ LESS.
         Fourth surface, one line, exactly as the note above promises. The
         summary sits first in the DOM and last visually (flex order), which
         the controller does not care about: it measures the PANEL.*/
      { item: '.guide-fig__disclose', summary: '.guide-fig__toggle', panel: '.guide-fig__panel' },
      /* The FAQ question rows. Fifth surface, one line — the measured-height
         animation is never re-implemented. */
      { item: '.raildoc__qa', summary: '.raildoc__qa-q', panel: '.raildoc__qa-panel' },
    ];
    const items = [];
    for (const s of SURFACES) {
      for (const el of document.querySelectorAll(s.item)) items.push(Object.assign(el, { __drSel: s }));
    }
    if (!items.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const DURATION = 380;
    const EASE = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

    items.forEach((details) => {
      const sel = details.__drSel || SURFACES[0];
      const summary = details.querySelector(sel.summary);
      const panel = details.querySelector(sel.panel);
      if (!summary || !panel) return;
      let anim = null;

      const run = (from, to, onDone) => {
        if (anim) anim.cancel();
        anim = panel.animate(
          { height: [from + 'px', to + 'px'] },
          { duration: DURATION, easing: EASE }
        );
        anim.onfinish = () => {
          panel.style.height = '';
          anim = null;
          if (onDone) onDone();
        };
        anim.oncancel = () => {
          anim = null;
        };
      };

      summary.addEventListener('click', (event) => {
        if (reduced.matches) return; // native snap
        event.preventDefault();

        if (details.open) {
          const from = panel.offsetHeight;
          run(from, 0, () => {
            details.open = false;
          });
        } else {
          details.open = true;
          const to = panel.scrollHeight;
          run(0, to);
        }
      });
    });
  });
}


/**/
/* The label flips with the state.*/
/*                                                                     */
/* No previous surface needed this: an FAQ or a PDP accordion keeps its*/
/* Question as the summary either way. A READ MORE control has to*/
/* Become READ LESS, or the reader is told to do what they just did.*/
/*                                                                     */
/* Driven off the <details> `toggle` event rather than the click, so it*/
/* Stays correct however the state changed - keyboard, a script, or the*/
/* Browser restoring it on back-navigation.*/
/**/
(function drGuideMoreLabels() {
  const paint = (d) => {
    const t = d.querySelector('[data-guide-more-text]');
    if (!t) return;
    const label = d.open ? t.dataset.labelLess : t.dataset.labelMore;
    if (label) t.textContent = label;
  };
  const wire = (root) => {
    (root || document).querySelectorAll('.guide-fig__disclose').forEach((d) => {
      if (d.__drMoreWired) return;
      d.__drMoreWired = true;          /* Prefixed - never collide with a platform IDL name*/
      d.addEventListener('toggle', () => paint(d));
      paint(d);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => wire());
  else wire();
  document.addEventListener('shopify:section:load', (e) => wire(e.target));
})();


/**/
/* Arriving at a panel's own anchor OPENS it.*/
/*                                                                     */
/* The Custom mega menu points at individual How-it-works panels*/
/* (/pages/custom#lead-times). Landing on a closed accordion and being*/
/* Left to find and click it is the same defect as landing mid-section:*/
/* The link promised an answer and delivered a heading.*/
/*                                                                     */
/* ⚠ It opens the panel WITHOUT animating it. The measured-height*/
/* Animation exists so a click does not snap; on arrival there is*/
/* Nothing to soften, and animating here would fight the scroll that*/
/* Motion.js is performing at the same moment (that handler owns*/
/* Same-page anchor scrolling and its formula is the one that lands).*/
/**/
(function drOpenAnchoredPanel() {
  const open = () => {
    const id = (window.location.hash || '').slice(1);
    if (!id) return;
    let el;
    try { el = document.getElementById(id); } catch (e) { return; }
    if (!el) return;
    const d = el.matches('details') ? el : el.closest('details');
    if (d && !d.open) d.open = true;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open);
  else open();
  window.addEventListener('hashchange', open);
})();
